import styled from 'styled-components';

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-muted);
  margin: 0 0 20px;
`;
